export default "__VITE_ASSET__BJwWBDX7__"